import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

function initSwipers() {
  const swiperElements = document.querySelectorAll('.mySwiper');
  
  if (!swiperElements.length) return;

  swiperElements.forEach((el) => {
    new Swiper(el, {
      effect: "cards",
      grabCursor: true,
      autoplay: {
        delay: 15000,
      },
    });
  });
}

document.addEventListener('DOMContentLoaded', initSwipers);